import Box from "@mui/material/Box";
import { FC } from "react";

import { getMediaUrl } from "@/configs";

import { DEFAULT_MASK_ICON_COLOR, DEFAULT_MASK_ICON_SIZE } from "./data";
import { MaskIconProps } from "./type";

const MaskIcon: FC<MaskIconProps> = ({
  src,
  size = DEFAULT_MASK_ICON_SIZE,
  color = DEFAULT_MASK_ICON_COLOR,
  className,
  sx,
}) => {
  const url = getMediaUrl(src, size);
  return (
    <Box
      className={className}
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        backgroundColor: color,
        WebkitMaskImage: `url("${url}")`,
        maskImage: `url("${url}")`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        ...sx,
      }}
    />
  );
};

export default MaskIcon;
